import { render, staticRenderFns } from "./ClockFillIcon.vue?vue&type=template&id=2b531e6c"
import script from "./ClockFillIcon.vue?vue&type=script&lang=js"
export * from "./ClockFillIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports